<template>
  <AppDialog
    :open="true"
    :dismissible="false"
    :title="t('auth.noActiveTreatmentTitle')"
    :description="t('auth.noActiveTreatmentDescription')"
  >
    <template #illustration>
      <span
        class="tw:mx-auto tw:my-4 tw:flex tw:items-center tw:justify-center tw:text-(--info-ink)"
      >
        <AppIcon name="info" size="illustration" />
      </span>
    </template>
    <template #footer>
      <Button :disabled="signingOut" @click="logout">{{ t('nkf.logout') }}</Button>
    </template>
  </AppDialog>
</template>
<script setup>
// 1. Import necessary components
import { shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/core/stores/auth.store';
import { useToastService } from '@/shared/composables/useToastService';
import AppDialog from '@/shared/components/AppDialog.vue';
import AppIcon from '@/shared/components/AppIcon.vue';
import { Button } from '@/shared/components/ui/button';
// 2. Use
const { t } = useI18n();
const router = useRouter();
const auth = useAuthStore();
const toast = useToastService();
// 3. Define a reactive variable
const signingOut = shallowRef(false);
// 4. Define methods or computed properties if needed
async function logout() {
  if (signingOut.value) {
    return;
  }
  signingOut.value = true;
  try {
    await auth.signOut();
  } catch {
    toast.error(t('auth.savedSessionCleanupFailed'));
  } finally {
    await router.replace('/auth/login');
    signingOut.value = false;
  }
}
// 5. VueJS Hooks
</script>
